class RecentBlogs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  async initSwiper() {
    new Swiper(this.querySelector('.recent-blogs__swiper'), {
      slidesPerView: 1,
      spaceBetween: 12,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }
}

customElements.define('recent-blogs', RecentBlogs);